import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,
  host: '',
  path: '',
  userName: '',
  password: '',
  sqlServerDataBaseConnectionString: '',
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  create({ commit }) {
    return systemSettingApi.createRk7(state)
      .then(({ data }) => commit('RK7_SETTING_CREATED', data))
      .catch((error) => {
        commit('RK7_SETTING_CREATE_FAILED', error.response.data);
        throw error;
      })
  },
  fetchById({ commit }, id) {
    commit("FORM_RESET");
    systemSettingApi.getRk7ById(id)
      .then(({ data }) => commit('RK7_SETTING_FETCHED', data))
      .catch(err => commit('RK7_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateRk7(state)
      .then(({ data }) => commit('RK7_SETTING_UPDATED', data))
      .catch((error) => {
        commit('RK7_SETTING_UPDATE_FAILED', error.response.data)
        throw error;
      })
  },
  resetForm({ commit }) {
    commit("FORM_RESET")
  },
}

const mutations = {
  RK7_SETTING_CREATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.created')
    store.dispatch('rk7Settings/fetchList')
  },
  RK7_SETTING_CREATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedDealer')
  },
  RK7_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
    store.dispatch('rk7Settings/fetchList')
  },
  RK7_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  RK7_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
